import script from "./Prediction.vue?vue&type=script&lang=ts&setup=true"
export * from "./Prediction.vue?vue&type=script&lang=ts&setup=true"

import "./Prediction.vue?vue&type=style&index=0&id=49e00169&lang=postcss&scoped=true"

import exportComponent from "/Users/benedge/Projects/KPMG-30-Voices-FS-2022/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e00169"]])

export default __exports__